/*
 *  Class Speed Check
 */
export
default class SpeedCheck {
    constructor() {
        this.form = document.getElementById('js-speed-check-form');
        this.loader = document.getElementById('js-speed-check-loader');
        this.button = document.getElementById('js-speed-check-button');
        this.results = document.getElementsByClassName('js-speed-check-result');
        this.errorNotFound= document.getElementById('js-error-not-found');
        this.error = document.getElementById('js-error');
    }

    activeResultElement() {
      for (let elm of this.results) {
        elm.classList.add('active');
      }
    }

    activeErrorElement() {
      this.error.classList.add('active');
    }

    activeErrorNotFoundElement() {
        this.errorNotFound.classList.add('active');
    }

    removeActiveElement() {
      for (let elm of this.results) {
        elm.classList.remove('active');
      }
      this.error.classList.remove('active');
      this.errorNotFound.classList.remove('active');
    }

    startLoader() {
      this.button.disabled = true;
      this.loader.classList.add('active');
    }

    stopLoader() {
      this.button.disabled = false;
      this.loader.classList.remove('active');
    }

    getMaxStream(services) {
        const max = services.reduce((prev, current) => {
            return prev.maxDownstream > current.maxDownstream ? prev : current;
        });
        return max;
    }

    getService(providers) {
        const providerKey = Object.keys(providers).find((key) => providers[key]);
        const services = Object.values(providers[providerKey].services);
        const service = this.getMaxStream(services);
        return service;
    }

    handleResponse(response) {
        if (response.results && response.results.length) {
            const { address, providers } = response.results[0];
            const { maxDownstream, maxUpstream } = this.getService(providers);
            const resultStream = `${maxDownstream} / ${maxUpstream}`;
            document.getElementById('js-result-address').innerHTML = address.label;
            document.getElementById('js-result-stream').innerHTML = resultStream;
            this.activeResultElement();
        } else if (response.results && !response.results.length) {
            this.activeErrorNotFoundElement();
        } else {
            this.activeErrorElement();
        }
    }

    createURLSearchParams(form) {
        const url = new URL(form.dataset.action);
        const params = {
            zip: form.zip.value,
            city: form.city.value,
            street: form.street.value,
            houseNr: form.houseNr.value,
        };
        Object.keys(params).forEach((key) => {
            const value = params[key];
            if (value) {
                url.searchParams.append(key, value);
            }
        });
        return url;
    }

    handleOnSubmit(event, form) {
        event.preventDefault();
        this.startLoader();
        this.removeActiveElement();

        const url = this.createURLSearchParams(form);
        const myRequest = new Request(url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + form.dataset.token,
            },
        });
        fetch(myRequest)
            .then((response) => response.json())
            .then((response) => {
                this.stopLoader();
                this.handleResponse(response);
            })
            .catch(() => {
                this.stopLoader();
                this.activeErrorElement();
            });
    }

    init() {
        if (this.form) {
            this.form.addEventListener('submit', (event) => this.handleOnSubmit(event, this.form));
        }
    }
}
